import * as actions from './actions';

const initialState = {
	updates: null,
	loading: false,
	error: false,
	errorDetail: null
};

function reduceFetchUpdates(state) {
	return {
		...state,
		...initialState,
		loading: true
	};
}

function reduceFetchUpdatesSuccess(state, action) {
	return {
		...state,
		updates: action.payload,
		loading: false,
		error: false,
		errorDetail: null
	};
}

function reduceFetchUpdatesError(state, action) {
	return {
		...state,
		error: true,
		errorDetail: action.payload,
		loading: false
	};
}

export const updates = (state, action) => {
	state = state || initialState;
	switch (action.type) {
		case actions.FETCH_UPDATES:
			return reduceFetchUpdates(state);
		case actions.FETCH_UPDATES_SUCCESS:
			return reduceFetchUpdatesSuccess(state, action);
		case actions.FETCH_UPDATES_ERROR:
			return reduceFetchUpdatesError(state, action);
		default:
			return state;
	}
};
